import { Component, OnInit, Input, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
import { TranslationService } from '../../shared/index';
import { FormElementProfile } from '../shared/model/profile/form-element-profile.model';

@Component({
  selector: 'wl-form-builder-profile-edit-element',
  templateUrl: 'form-builder-profile-edit-element.component.html',
  //providers: [FormBuilder, UtilService, NotificationService, FormElementTypes, FormFields, NavigationService]
    standalone: false
})
export class FormBuilderProfileEditElementComponent implements OnChanges {
  @Input() isOrg = false;
  private _translationService: TranslationService;

  public relatedProfileSettings = new FormElementProfile();

  public constructor(translationService: TranslationService) {
    this._translationService = translationService;
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.isOrg) {
      this.relatedProfileSettings = new FormElementProfile(simpleChanges?.isOrg?.currentValue ?? false);
    }
  }
}
